import { NavLink } from "react-router";
import { cn } from "@/utils";
import { Icon } from "../icon";

interface Props {
	size?: number | string;
	className?: string;
}
function Logo({ size = 36, className }: Props) {
	return (
		<NavLink to="/" className={cn(className)}>
			<Icon icon="local:logo" size={size} color="var(--colors-palette-primary-default)" />
		</NavLink>
	);
}

export default Logo;
